(function (){
	"use strict";

    var bConfig = require('./config.js');
    var siteBuilder = require('./builder.js');
    var editor = require('./styleeditor.js').styleeditor;
    var appUI = require('./ui.js').appUI;

    var imageLibrary = {

        imageModal: document.getElementById('imageModal'),
        inputImageUpload: document.getElementById('imageFile'),
        buttonUploadImage: document.getElementById('uploadImageButton'),
        imageLibraryLinks: document.querySelectorAll('.images > .image .buttons .btn-primary, .images .imageWrap > a'),//used in the library, outside the builder UI
        myImages: document.getElementById('myImages'),//used in the image library, outside the builder UI

        init: function(){

            $(this.imageModal).on('show.bs.modal', this.imageLibrary);
            $(this.inputImageUpload).on('change', this.imageInputChange);
            $(this.buttonUploadImage).on('click', this.uploadImage);
            $(this.imageLibraryLinks).on('click', this.imageInModal);
            $(this.myImages).on('click', '.buttons .btn-danger', this.deleteImage);

        },


        /*
            image library modal
        */
        imageLibrary: function() {

            //load images
            var images = this.querySelectorAll('.modal-body img[data-original-src]'),
                image;

            for ( image in images ) {
                if ( images.hasOwnProperty(image) ) {
                    images[image].setAttribute('src', images[image].getAttribute('data-original-src'));
                    images[image].removeAttribute('data-original-src');
                }
            }

            $('#imageModal').off('click', '.image button.useImage');

            $('#imageModal').on('click', '.image button.useImage', function(){

                //update live image
                if ( editor.activeElement.element.hasAttribute('src') ) $(editor.activeElement.element).attr('src', $(this).attr('data-url'));

                //if this is a lightbox image
                if ( $(editor.activeElement.element).parents(bConfig.imageLightboxWrapper).size() > 0 ) {
                    $(editor.activeElement.element).parents(bConfig.imageLightboxWrapper).find('a').attr('href', $(this).attr('data-url'));
                }

                $(editor.activeElement.element).on('load', function () {
                    
                    editor.activeElement.parentBlock.heightAdjustment();

                }.bind(this));

                //update image URL field
                $('input#imageURL').val( $(this).attr('data-url') );

                //hide modal
                $('#imageModal').modal('hide');

                //height adjustment of the iframe heightAdjustment
				//editor.activeElement.parentBlock.heightAdjustment();

                //we've got pending changes
                siteBuilder.site.setPendingChanges(true);

                $(this).unbind('click');

            });

        },


        /*
            image upload input chaneg event handler
        */
        imageInputChange: function() {

            if( $(this).val() === '' ) {
                //no file, disable submit button
                $('button#uploadImageButton').addClass('disabled');
            } else {
                //got a file, enable button
                $('button#uploadImageButton').removeClass('disabled');
            }

        },


        /*
            upload an image to the image library
        */
        uploadImage: function() {

            if( $('input#imageFile').val() !== '' ) {

                //remove old alerts
                $('#imageModal .modal-alerts > *').remove();

                //disable button
                $('button#uploadImageButton').addClass('disable');

                //show loader
                $('#imageModal .loader').fadeIn(500);

                var form = $('form#imageUploadForm');
                var formdata = false;

                if (window.FormData){
                    formdata = new FormData(form[0]);
                }

                var formAction = form.attr('action');

                $.ajax({
                    url : formAction,
                    data : formdata ? formdata : form.serialize(),
                    cache : false,
                    contentType : false,
                    processData : false,
                    dataType: "json",
                    type : 'POST'
                }).done(function(ret){

                    //enable button
                    $('button#uploadImageButton').addClass('disable');

                    //hide loader
                    $('#imageModal .loader').fadeOut(500);

                    if( ret.responseCode === 0 ) {//error

                        $('#imageModal .modal-alerts').append( $(ret.responseHTML) );

                    } else if( ret.responseCode === 1 ) {//success

                        //append my image
                        $('#myImagesTab > *').remove();
                        $('#myImagesTab').append( $(ret.myImages) );
                        $('#imageModal .modal-alerts').append( $(ret.responseHTML) );

                        setTimeout(function(){$('#imageModal .modal-alerts > *').fadeOut(500);}, 3000);

                    }

                });

            } else {

                alert('No image selected');

            }

        },


        /*
            displays image in modal
        */
        imageInModal: function(e) {

            e.preventDefault();

    		var theSrc = $(this).closest('.image').find('img').attr('src');

    		$('img#thePic').attr('src', theSrc);

    		$('#viewPic').modal('show');

        },


        /*
            deletes an image from the library
        */
        deleteImage: function(e) {

            e.preventDefault();

    		var toDel = $(this).closest('.image');
    		var theURL = $(this).attr('data-img');

    		$('#deleteImageModal').modal('show');

    		$('button#deleteImageButton').click(function(){

    			$(this).addClass('disabled');

    			var theButton = $(this);

    			$.ajax({
                    url: appUI.siteUrl+"asset/delImage",
    				data: {file: theURL},
    				type: 'post'
    			}).done(function(){

    				theButton.removeClass('disabled');

    				$('#deleteImageModal').modal('hide');

    				toDel.fadeOut(800, function(){

    					$(this).remove();

    				});

    			});


    		});

        }

    };

    imageLibrary.init();

}());


//////////////////
// WEBPACK FOOTER
// ./assets/js/modules/imageLibrary.js
// module id = 89
// module chunks = 1 2